    
const invalidProps = (callback, delay) =>  {
    if (typeof callback !== 'function' || isNaN(delay)) throw new Error('invalid params')
};

export const throttle = (callback, delay = 0) => {
    invalidProps(callback, delay)
    let wait = false;

    return (...args) => {
        if (wait) return;

        callback(...args)
        wait = true
        setTimeout(() => {
            wait = false;
        }, delay);
    }
}

export const debounce = (callback, delay) => {
    invalidProps(callback, delay)

    let timer;
    return function (...args) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        callback(...args)
      }, 500);
    };
  };